
import { Injectable } from '@angular/core';
import { HttpRequest, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as CommonConstants from 'src/app/utils/common.constants';
import { Router } from '@angular/router';
import { SharedService } from '../utils/shared.service';
import { retry, catchError } from 'rxjs/operators';
import swal from 'sweetalert2';

@Injectable()
export class AuthService {

  cachedRequests: Array<HttpRequest<any>> = [];

  constructor(private router: Router, private http: HttpClient, private sharedService: SharedService) {

  }

  /**
   * To refresh the access token.
   * @returns returns the new refresh token on success.
   */
  refreshToken(): Observable<any> {
    let client_id = CommonConstants.CLIENT_ID;
    let client_secret = 'secret';
    let basicheader = btoa(client_id + ':' + client_secret);
    let headers = new HttpHeaders();
    headers.set('Authorization', 'Basic ' + basicheader);
    return this.http.get(CommonConstants.REFRESH_TOKEN + localStorage.getItem(CommonConstants.REFRESH_TOKEN), { headers: headers })
     // .catch((e: any) => Observable.throw(this.errorHandler(e)))
     .pipe(
        retry(1),
        catchError((e: any) => Observable.throw(this.errorHandler(e)))
    );
  }

  errorHandler(error: any): void {
    Observable.throw("");
  }


  /**
   * logging out from the application and handle login message using the code.
   * @param code error codes defined for token failure
   */
  logoutUser(code: number) {
    switch (code) {
      case CommonConstants.REFRESH_TOKEN_FAILED:
        swal.fire({
          title: 'Session Expired',
          text: 'your session has been expired please re login',

          timer: 3000,
          onOpen: () => {
            swal.showLoading();
            window.location.reload();
          }
        }).then((result) => {
          if (result.isDismissed) {
            localStorage.clear();
            this.sharedService.setAuthenticated(false);
            //$('#wrapper').attr("style", "display:none");
            //set loader to false
            // this.loaderService.display(false);
            this.router.navigate([CommonConstants.REDIRECT_LOGOUT_URI]);
            // window.location.reload();
          }
        })
      /* case 0:
           swal({
               title: 'Login Failed',
               text: 'please try after some time',

               timer: 3000,
               onOpen: () => {
                   swal.showLoading()
               }
           }).then((result) => {
               if (result.dismiss === 'timer') {
                   localStorage.clear();
                   this.sharedService.setAuthenticated(false);
                   this.router.navigate([AppUtils.REDIRECT_LOGOUT_URI]);
                   // window.location.reload();
               }
           })*/
      default:
        localStorage.clear();
        this.sharedService.setAuthenticated(false);
        //$('#wrapper').attr("style", "display:none");
        this.router.navigate([CommonConstants.REDIRECT_LOGOUT_URI]);
    }

    return Observable.throw("");
  }

  showErrorMessage(message : any, type : string ){
    const requiredAttempts: number = 4 - parseInt(localStorage.getItem('failed-login-attempts'));
    let errorMessage: string = message;
    if(type === 'login'){
      if(requiredAttempts <= 0){
        errorMessage=message;
      }else{
        errorMessage = message +'<br>'+'<div class="login-error">'+'<i class="fa fa-exclamation-triangle"></i>'+ CommonConstants.FAILED_ATTEMPTS.replace('ATTEMPTS',requiredAttempts.toString())+'</div>';
      }
    }else if(type === 'failed_request'){
      errorMessage = '<div class="login-error">'+'<i class="fa fa-exclamation-triangle"></i>'+ message +'</div>';
    }
    // let errorMessage: string = message.error.error_description;
    // if(requiredAttempts <= 0 ){
    //   errorMessage=message.error.error_description;
    // }else{
    //   errorMessage = message;
    // }

    swal.fire({
     // html: errorMessage,
     // type: 'error'
  }).then((result) => {
         // localStorage.clear();
         
          this.sharedService.setAuthenticated(false);
          
  })
  }
}


